import React, { Component } from 'react';
import { Row, Col, Button, Translate, Card, CardContent, Input, Form, FormField, Icon, Seperator, } from '$common';
import CSSModules from 'react-css-modules';
import { groupBy, omit, isEmpty, cloneDeep } from 'lodash';
import { errors } from '$lib/normalize';
import GetCountry from '$lib/get-country';
import TaskForm from '../../task-form/task-form';
import { ProjectSummary, Tutorial, Brief, Targeting } from '$components/projects';
import { QuestionAnswerTypeMap } from '$constants/task-form/index';
import style from './create.scss';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { saveDraft } from '$lib/draft-manager';
import AgeGroups from '$constants/age-groups.json';

let autoDraftMessage = Translate.get('waiting_for_new_changes');

const steps = [
  Translate.get('define_your_research'),
  Translate.get('targeting_title'),
  Translate.get('prepare_questions')
]

@CSSModules(style, {allowMultiple: true})
export default class Create extends Component {
  state = {
    stepIndex: 0,
    form: this.props.form || { questions: [] },
    questionCost: 0, extraQuestionCost: 0, imageCaptureCost: 0, imageUploadCost: 0,
    projectFormErrors: {},
    questionFormErrors: {},
    isDoneDisabled: true,
    selectedTemplate: undefined,
    template: this.props.template || {
      variables: {}
    },
    area_id: null,
    summaryIsOpen: false
  };

  constructor(props) {
    super(props);

    const autoDraftInterval = 10000;

    setInterval( () => {
      this.initDraftManager();
    }, autoDraftInterval);
  }

  initDraftManager() {
    const { project } = this.state;
    const { questions } = this.props;

    try {
      if (questions.length > 0) {
        const data = saveDraft({ project, questions });
        autoDraftMessage = data.message;
      }
    } catch(e) {}
  }

  componentWillMount() {
    const { projectDefaults } = this.props;

    if (projectDefaults.id) {
      projectDefaults.scheduleProject = false;
      projectDefaults.limitAvailability = false;
      projectDefaults.availability = {
        ...projectDefaults.scheduling
      };

      if (projectDefaults.targetings.length < 1) {
        projectDefaults.targetings = [
          {
            max_submission_count: 100,
            age_range: { young: false, adult: false, old: false },
            gender: { male: false, female: false }
          }
        ]
      } else {
        let targetings = [];

        projectDefaults.targetings.map((targeting) => {
          const female = (targeting.target_group.gender !== 'male' && true);
          const male = (targeting.target_group.gender !== 'female' && true);

          targetings.push({
            id: targeting.id,
            max_submission_count: targeting.max_submission_count,
            gender: { male, female },
            age_range: { young: false, adult: false, old: false },
          });
        });

        projectDefaults.targetings = targetings;
      }
    }
  }

  componentWillReceiveProps() {
    this.calculatePrice();
  }

  handleProjectChange(field) {
    return value => {
      this.setState({
        ...this.state.project,
        [field]: value
      });
    }
  }

  handleVariableChange(field) {
    return value => {
      this.setState({
        form: {
          ...this.state.form,
          variables: {
            ...this.state.form.variables,
            [field]: value
          }
        }
      });
    }
  }

  goTo(index) {
    this.calculatePrice();
/* 
    switch (index) {
      case 0:
        window.Intercom('trackEvent', 'OPENED_PROJECT_DEFINITION');
      break;
      case 1:
        window.Intercom('trackEvent', 'OPENED_TARGETING');
      break;
      case 2:
        window.Intercom('trackEvent', 'OPENED_SURVEY_BUILDER');
      break;
    }
*/
    this.setState({ stepIndex: index });
  }

  calculatePrice() {
    const { project } = this.state;
    const { questions } = this.props;
    const groupedQuestions = groupBy(questions, 'question_type');

    let maxSubmissionCount = 1;
    if (project) {
      project.targetings.map( i => {
        maxSubmissionCount += parseInt(i.max_submission_count);
      })
    }

    let totalAmount = parseFloat(0);
    let questionCost = parseFloat(1);
    let extraQuestionCost = parseFloat(0);
    let imageCaptureCost = parseFloat(0);
    let imageUploadCost = parseFloat(0);

    if (questions.length > 10) {
      extraQuestionCost = parseFloat((questions.length-10) * 0.20);
    }

    if (typeof groupedQuestions['multiple_image_capture'] !== "undefined") {
      imageCaptureCost = parseFloat(groupedQuestions['multiple_image_capture'].length * 0.50)
    }

    if (typeof groupedQuestions['multiple_image_upload'] !== "undefined") {
      imageUploadCost = parseFloat(groupedQuestions['multiple_image_upload'].length * 0.50)
    }

    if (typeof project !== "undefined") {
      if (typeof maxSubmissionCount !== "undefined" && maxSubmissionCount !== "") {
        if (project.is_targeting_enabled) {
          totalAmount = ((
            this.state.questionCost +
            this.state.extraQuestionCost +
            this.state.imageCaptureCost +
            this.state.imageUploadCost) *
            parseFloat(maxSubmissionCount)) * 2;
        } else {
          totalAmount = (
            this.state.questionCost +
            this.state.extraQuestionCost +
            this.state.imageCaptureCost +
            this.state.imageUploadCost) *
            parseFloat(maxSubmissionCount);
        }
      } else {
        if (project.is_targeting_enabled) {
          totalAmount = (
            this.state.questionCost +
            this.state.extraQuestionCost +
            this.state.imageCaptureCost +
            this.state.imageUploadCost) * 2;
        } else {
          totalAmount = 
            this.state.questionCost +
            this.state.extraQuestionCost +
            this.state.imageCaptureCost +
            this.state.imageUploadCost;
        }
      }
      if (project.is_geo_configuration_enabled && project.area_id) {
        totalAmount *= 2;
      }
    } else {
      totalAmount = 
        this.state.questionCost +
        this.state.extraQuestionCost +
        this.state.imageCaptureCost +
        this.state.imageUploadCost;
    }

    this.setState({ questionCost, extraQuestionCost, imageCaptureCost, imageUploadCost, totalAmount });
  }

  onSubmit(data) {
    this.setState({ formIsSubmitting: true });
    let values = cloneDeep(data);
    try{
      values.scheduling_attributes = {};
      values.account_id = this.props.projectDefaults.account.id;
      values.customer_name = values.name;
      values.system_short_description = values.short_description
      values.system_name = values.name;
      values.country_id = 200;

      if (values.scheduleProject) {
        values.scheduling_attributes = {
          ...values.scheduling_attributes,
          ...values.scheduling
        }
      } else {
        values.scheduling_attributes = {
          starts_at: '-infinity',
          finishes_at: 'infinity'
        }
      }

      if (values.limitAvailability) {
        values.scheduling_attributes = {
          ...values.availability,
          ...values.scheduling_attributes
        }
      } else {
        values.scheduling_attributes.available_on_monday = true;
        values.scheduling_attributes.available_on_tuesday = true;
        values.scheduling_attributes.available_on_wednesday = true;
        values.scheduling_attributes.available_on_thursday = true;
        values.scheduling_attributes.available_on_friday = true;
        values.scheduling_attributes.available_on_saturday = true;
        values.scheduling_attributes.available_on_sunday = true;
        values.scheduling_attributes.available_from = 0;
        values.scheduling_attributes.available_to = 86400;
      }

      values.primary_project_categorizing_attributes = {
        project_category_id: 51
      }

      values.max_submission_count = 0;
      let manipulatedTargetings = [];

      values.targetings.map( (targeting, index) => {
        if (!targeting._destroy) {
          values.max_submission_count += parseInt(targeting.max_submission_count);
        }

        manipulatedTargetings.push({
          max_submission_count: targeting.max_submission_count,
          target_group_attributes: {
            age_range: [], gender: 'unspecified'
          }
        });
        let targetGroup = manipulatedTargetings[index].target_group_attributes;

        if (targeting.id) {
          manipulatedTargetings[index].id = targeting.id;

          if (targeting._destroy) {
            manipulatedTargetings[index]._destroy = true;
          }
        }

        Object.keys(targeting.age_range).map( group => {
          if (targeting.age_range[group]) {
            AgeGroups[group].map(age => {
              targetGroup.age_range.push(age);
            })
          }
        });

        if (targeting.gender.male && targeting.gender.female || !targeting.gender.male && !targeting.gender.female) {
          targetGroup.gender = 'unspecified'
        } else {
          Object.keys(targeting.gender).map(gender => {
            if (targeting.gender[gender]) {
              targetGroup.gender = gender;
            }
          })
        }

        if (targetGroup.age_range.length > 0) {
          const min_age = Math.min(...targetGroup.age_range);
          const max_age = Math.max(...targetGroup.age_range);
          targetGroup.age_range = `[${min_age},${max_age}]`;
        } else {
          targetGroup.age_range = "[18,99]";
        }

        if (targeting.is_custom_age_range_enabled) {
          targetGroup.age_range = `[${targeting.min_age || 18},${targeting.max_age || 99}]`;
        }
      });

      if (values.is_targeting_enabled) {
        values.targetings_attributes = manipulatedTargetings;
      } else {
        values.targetings = [];
      }

      values.reward = (this.state.totalAmount / values.max_submission_count) / 2;
      values.price = this.state.totalAmount;

      values.short_description = values.short_description_1 || '' + ' ' + values.short_description_2 || '' + ' ' + values.short_description_3 || '';

      this.setState({ project: values });

      const projectFormRequiredFields = [
        { name: 'name', label: Translate.get('task_name') },
        { name: 'short_description_1', label: Translate.get('description') },
        { name: 'short_description_2', label: Translate.get('goals_of_this_research') },
        { name: 'short_description_3', label: Translate.get('important_points') }
      ];
      const questionFormRequiredFields = [
        { name: 'label', label: 'Question' }
      ];
      let projectFormErrors = [];
      let questionFormErrors = [];
      let modalContent = [];

      projectFormRequiredFields.map(item => {
        if (typeof values[item.name] !== "undefined") {      
          if (values[item.name].trim() === "") {
            projectFormErrors.push({ "attribute": item.name, "errors": ["Can't be blank"] });
            modalContent.push(item.label);
            this.setState({ projectFormErrors: errors(projectFormErrors) });
          }
        }
      });

      this.props.questions.map((question, index) => {
        if (question.question_type === 'range') {
          const optionLength = typeof question.interval !== "undefined" ? (question.max - question.min) / question.interval : question.max - question.min;
          let optionValue = parseInt(question.min);
          for (var i = 0; i <= optionLength; i++) {
            if (i !== 0) {
              optionValue += parseInt(question.interval);
            }
            question.question_options.push({
              answer_points: 0,
              label: optionValue,
              jump_ids: [],
              optional_label: i === 0 ? question.min_label : null
            });
          }
          if (question.question_options.length > 0) {
            const length = question.question_options.length-1;
            question.question_options[length].optional_label = question.max_label;
          }
        }

        if (question.question_type === 'yes_no') {
          question.question_options.push(
            {
              answer_points: 0,
              label: 'No',
              optional_label: 0,
              jump_ids: []
            },
            {
              answer_points: 0,
              label: 'Yes',
              optional_label: 1,
              jump_ids: []
            }
          );
        }
        
        questionFormRequiredFields.map( item => {
          if (typeof question[item.name] === "undefined") question[item.name] = "";
          if (question[item.name].trim() === "") {
            questionFormErrors.push({ "attribute": `questions[${index}].${item.name}`, "errors": ["Can't be blank"] });
            modalContent.push(`${item.label} (${index+1})`);
            if (QuestionAnswerTypeMap['SelectionAnswer'].indexOf(question.question_type) !== -1) {
              modalContent.push(`${item.label} (${index+1}) options`);
            }
            this.setState({ questionFormErrors: errors(questionFormErrors) });
          }
        })
      });

      if (modalContent.length > 0) {
        let modalContentHTML = modalContent.map( (item, index) => ( <p key={index}><b>{item}</b></p> ));
        this.props.showAlert(Translate.get('this_fields_required'), <div>{modalContentHTML}</div>, 'warning');
        this.setState({ stepIndex: 0, formIsSubmitting: false });
      } else {
        // window.Intercom('trackEvent', 'SUBMITTED_PROJECT');

        this.props.onSubmit(
          omit(
            values,
            'short_description_1',
            'short_description_2',
            'short_description_3',
            'is_targeting_enabled',
            'targetings',
            'is_geo_configuration_enabled'
          ),
          { questions: this.props.questions, variables: this.state.form.variables },
          this.state.selectedTemplate
        );
      }
    } catch(e) {
      this.setState({ formIsSubmitting: false });
      console.error(e.message);
    }
  }

  selectTemplate(id) {
    this.setState({ selectedTemplate: id });
    this.props.getTaskFormTemplate(id);
    setTimeout(() => {
      this.setState({
        form: {
          ...this.props.template
        }
      })
      this.calculatePrice();
    }, 500);
  }

  addTargetingGroup() {
    const { project } = this.state;
    project.targetings.push({ max_submission_count: 100 });
    this.setState({ project })
  }

  removeTargetingGroup(index) {
    const { project } = this.state;
    if (project.targetings[index].id) {
      project.targetings[index]._destroy = true;
    } else {
      project.targetings.splice(index, 1);
    }
    this.setState({ project });
  }

  formOnKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  get infoButton() {
    return(
      <div styleName="info-button"></div>
    )
  }

  render() {
    const { projectDefaults, templates, template, isTemplateFetching, questions, errors } = this.props;
    const { stepIndex, project, totalAmount, projectFormErrors, selectedTemplate, summaryIsOpen, formIsSubmitting } = this.state;

    return (
      <div styleName="root">
        <span styleName="auto-draft-message">{autoDraftMessage}</span>

        <div styleName="steps">
          <ul>
            {
              steps.map( (step, index) => (
                <li key={index}>
                  <a data-index={index + 1} onClick={() => this.goTo(index)} styleName={stepIndex === index ? 'active' : ''}>
                    <span>{step}</span>
                  </a>
                </li>
              ))
            }
          </ul>
        </div>

        <Form
          errors={{ ...projectFormErrors, ...errors }}
          defaults={projectDefaults}
          onKeyPress={::this.formOnKeyPress}
          onSubmit={(values) => this.onSubmit(values)}
          onChange={::this.handleProjectChange('project')}
        >
          <Row justify="center">
            <Col>
              {
                stepIndex === 0 ?
                  <Brief
                    defaults={projectDefaults}
                  />
                : ''
              }

              {
                stepIndex === 1 ?
                  <Targeting
                    project={project}
                    addTargetingGroup={::this.addTargetingGroup}
                    removeTargetingGroup={::this.removeTargetingGroup}
                  />
                : ''
              }

              <ProjectSummary
                data={project}
                onClose={ () => this.setState({ summaryIsOpen: false }) }
                questionCount={questions.length || 0}
                totalAmount={`${parseInt(totalAmount)} ${GetCountry.currencyCode}`}
                isOpen={summaryIsOpen}
                formIsSubmitting={formIsSubmitting}
              />
            </Col>
          </Row>
        </Form>

        <Card style={{ display: stepIndex === 2 ? 'block' : 'none' }}>
          <CardContent extraPadding>
            {
              templates.length > 0 ?
                <div styleName="item-wrapper">
                  <Seperator style={{ marginTop: '25px' }}>
                    <span style={{ marginRight: '10px'}}>{Translate.get('templates')}</span>
                    <Tooltip placement="top" overlay={Translate.get('templates_info')}>
                      {this.infoButton}
                    </Tooltip>
                  </Seperator>
                  {
                    templates.map( (item, index) => (
                      <div styleName="item" key={index} onClick={ () => this.selectTemplate(item.id) }>
                        {item.name}
                        <Icon name="angle-right" />
                      </div>
                    ))
                  }
                </div>
              : null
            }
            {
              typeof selectedTemplate === "number" ?
                !isEmpty(template.variables) ?
                  <Row key={0}>
                    <Col><Seperator style={{ marginTop: '26px' }} key={0}>{Translate.get('variables')}</Seperator></Col>
                    {
                      Object.keys(template.variables).map( (item, index) => (
                        <Col md="1/3" key={index}>
                          <FormField name={item} label={item}>
                            <Input onBlur={::this.handleVariableChange(item)}/>
                          </FormField>
                        </Col>
                      ))
                    }
                    <br />
                  </Row>
                : ''
              : ''
            }

            <TaskForm
              initialValues={{ questions }}
              handleSubmit={(values) => {}}
            />
          </CardContent>
        </Card>

        <Tutorial />

        {
          !summaryIsOpen ?
            <div styleName="total-amount">
              {
                questions.length > 0 ? 
                  <span>{Translate.get('total_amount')}: {parseInt(totalAmount)} {GetCountry.currencyCode}</span>
                : 
                  <span>{Translate.get('zero_price_state')}</span>
              }
              {
                project ? 
                  project.is_targeting_enabled || project.is_geo_configuration_enabled ? 
                    <Tooltip placement="top" overlay={Translate.get('how_we_calculating_price')}>
                      {this.infoButton}
                    </Tooltip>
                  : ''
                : ''
              }
              {
                stepIndex < 2 ?
                  <Button type="success" onClick={() => this.goTo(stepIndex+1)} style={{ marginRight: '15px' }}>{Translate.get('next')}</Button>
                : ''
              }
              {
                questions.length > 0 && typeof project !== "undefined" ?
                  <Button type="primary" onClick={() => {
                    this.calculatePrice();
                    this.setState({ summaryIsOpen: true });
                    // window.Intercom('trackEvent', 'OPENED_CHECKOUT');
                  }}>{Translate.get('send_draft')}</Button>
                : <Button type="primary" disabled>{Translate.get('send_draft')}</Button>
              }
            </div>
          : ''
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/create/create.js